import * as React from "react";

function SvgTieClips(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M19.437 11.754H2.19a1.128 1.128 0 01-1.127-1.127A1.034 1.034 0 012.19 9.5a23.319 23.319 0 014.03.71 33.987 33.987 0 007 1.092c4.125 0 4.244-1.771 4.244-1.973a.511.511 0 00-.5-.514.488.488 0 00-.5.485c-.037.279-.691 1-3.245 1a33.324 33.324 0 01-6.778-1.065A23.164 23.164 0 002.19 8.5a2.013 2.013 0 00-2.127 2.127 2.129 2.129 0 002.127 2.127h17.247a.5.5 0 000-1z"
        fill="#231f20"
      />
    </svg>
  );
}

export default SvgTieClips;
